import { render, staticRenderFns } from "./vizOtchetImotBezDev.vue?vue&type=template&id=2f375587"
import script from "./vizOtchetImotBezDev.vue?vue&type=script&lang=js"
export * from "./vizOtchetImotBezDev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports